import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus-green",
  "use": "icon-plus-green-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus-green\">\n<path d=\"M9 4.5H5.5V1C5.5 0.726667 5.27333 0.5 5 0.5C4.72667 0.5 4.5 0.726667 4.5 1V4.5H1C0.726667 4.5 0.5 4.72667 0.5 5C0.5 5.27333 0.726667 5.5 1 5.5H4.5V9C4.5 9.27333 4.72667 9.5 5 9.5C5.27333 9.5 5.5 9.27333 5.5 9V5.5H9C9.27333 5.5 9.5 5.27333 9.5 5C9.5 4.72667 9.27333 4.5 9 4.5Z\" fill=\"#93BA30\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol